import React, { memo, useEffect, useState } from 'react';

import { IconChevronDownOutline, IconChevronUpOutline } from '@zillow/constellation-icons';

import { Box, Icon, Menu } from '@zillow/constellation-10';

type Props = {
  title?: React.ReactNode;
  useLeftNav?: boolean;
  // allows parent to control the dropdown open state via prop for left nav layout
  pIsOpen?: boolean;
  onClose?(): void;
  onOpen?(): void;
  children?: React.ReactNode;
};

const DropdownMenu = ({
  onClose,
  onOpen,
  title = null,
  useLeftNav = false,
  pIsOpen = false,
  children = null,
}: Props) => {
  const [isOpen, setIsOpen] = useState(pIsOpen);

  useEffect(() => {
    if (useLeftNav && pIsOpen !== isOpen) {
      setIsOpen(pIsOpen);
    }
  }, [pIsOpen, useLeftNav]);

  const IconChevron = isOpen ? IconChevronUpOutline : IconChevronDownOutline;

  const handleClose = () => {
    if (onClose) {
      onClose();
    }

    if (useLeftNav === false) {
      setIsOpen(false);
    }
  };

  const handleOpen = () => {
    if (onOpen) {
      onOpen();
    }

    if (useLeftNav === false) {
      setIsOpen(true);
    }
  };

  return (
    <Menu.Root
      onOpenChange={(open) => (open ? handleOpen() : handleClose())}
      offset={useLeftNav ? { mainAxis: 175, crossAxis: 20 } : undefined}
      placement={useLeftNav ? 'right' : 'bottom-start'}
      data-test="DropdownMenu"
      open={isOpen}
    >
      <Menu.Trigger>
        <Box role="button" css={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer' }}>
          {title}
          <Box css={{ marginRight: '100' }} />
          {useLeftNav === false && (
            <Icon
              render={<IconChevron />}
              size="sm"
              css={{ color: 'icon.accent.brand.hero', position: 'relative', top: '2px' }}
            />
          )}
        </Box>
      </Menu.Trigger>
      <Menu.Portal role="Menu">
        <Menu.Content css={{ display: { base: 'none', xl: 'block' } }}>{children}</Menu.Content>
      </Menu.Portal>
    </Menu.Root>
  );
};

export default memo(DropdownMenu);
